{
	"default": {
		"logout": "Logout",
		"changeLanguage": "Change Language",
		"changeSystemLanguage": "Change System Language",
		"changeLayout": "Change Layout"
	},
	"selectLanguageModal": {
		"selectLanguage": "Select the language",
		"cancel": "Cancel",
		"confirm": "Confirm"
	},
	"org": {
		"panel": "Places",
		"employee": "Team Access",
		"crm": "CRM",
		"categories": "Categories",
		"reports": "Reports",
		"recharge": "Recharge",
		"stock": "Stock",
		"giftback": "Giftback",
		"fiscal": "Fiscal",
		"taxRegistration": "Tax Registration",
		"internalSalesCampaign": "Internal sales campaign",
		"productRegistration": "Product Base Registration",
		"clientArea": "Data Hub",
		"customersList": "Customer List",
		"stockInventory": "Product Base Registration",
		"taxData": "Tax Data",
		"fiscalSettings": "Fiscal Data",
		"financialReport": "Reports",
		"satisfactionSurvey": "Satisfaction Survey",
		"customers": "Customer's Area",
		"sendingMessages": "Sending Messages",
		"loyalty": "Loyalty Programs",
		"communication": "Communication Campaigns",
		"chartOfAccounts": "Chart of Accounts",
		"fiscalBoard": "Fiscal Board",
		"vendors": "Vendors",
		"team": "Team",
		"integrations": "Integrations",
		"settings": "Settings",
		"messagesAnalytics": "Messages Report",
		"catering": "Catering"
	},
	"place": {
		"events": "Events",
		"businessInteligence": "Business Intelligence",
		"pdvTeam": "POS Operators",
		"products": "Products",
		"menu": "Menu",
		"bars": "Bars & Sectors",
		"opened": "Opened",
		"clientArea": "Data Hub",
		"closed": "Closed",
		"crm": "CRM",
		"reports": "Reports",
		"preChargeLabel": "Pre-charge",
		"inventoryControl": "Inventory control",
		"receptive": "Receptive",
		"productAndMenu": "Product & Menu",
		"clients": "Customers",
		"tagGroups": "Tag Groups",
		"reserve": "Waiting queue",
		"reserveV2": "Reservation management",
		"tickets": "Tickets",
		"guestList": "Guest List",
		"financialReport": "Financial Reports",
		"barReports": "Bar Reports",
		"salesReport": "Sales reports",
		"tableReports": "Table Reports",
		"prechargeReports": "Precharge by Spreadsheet",
		"ticketsReport": "Ticket Reports",
		"storage": "Storage",
		"extract": "Extract",
		"invoices": "Invoices",
		"promotions": "Bonuses, Promotions and Discounts",
		"pos": "POS Sales",
		"cashFlow": "Financial",
		"zigAccount": "Zig Account",
		"delivery": "Delivery",
		"deliveryOrders": "Orders",
		"deliveryReport": "Reports",
		"deliveryMenus": "Menus",
		"deliveryOrdersManager": "Order Manager",
		"deliveryIntegrations": "Integrations",
		"deliverySettings": "Settings",
		"transferReport": "Transfer Report",
		"multivendor": "Multi-vendor",
		"precharge": "Precharge Websites",
		"whatsup": "What's Up?",
		"passwordCard": "Password card",
		"audits": "Audits",
		"settings": "Settings",
		"contracts": "Contracts",
		"placeData": "Contract Information",
		"rechargeManagement": "Balance Management",
		"financialFile": "Financial File",
		"generalConfig": "General Configuration",
		"operationReport": "Operation Report",
		"config": "Settings",
		"kds": "Order Manager (KDS)",
		"tableMap": "Table Map",
		"tableMapAttendanceManagement": "Attendance Management",
		"kdsConfig": "Manage KDS",
		"kdsReport": "Production report",
		"hawkersReport": "Hawkers Report",
		"catering": "Catering",
		"wizardSummary": "Wizard Summary",
		"paymentLinks": "Payment links"
	},
	"event": {
		"panel": "Panel",
		"businessIntelligence": "General Panel",
		"eventPanel": "Event Panel",
		"reports": "Reports",
		"clientArea": "Data Hub",
		"customers": "Customers",
		"clients": "Customers Information",
		"conference": "Event Conference",
		"guestList": "Guest Lists",
		"financialReport": "Financial Reports",
		"barReports": "Bar Reports",
		"salesReport": "Sales reports",
		"tableReports": "Table Reports",
		"ticketsReport": "Ticket Reports",
		"sellChip": "Card-free Sales",
		"bookings": "Bookings",
		"devices": "Devices",
		"multivendor": "Multi-vendor",
		"zigTag": "Zig Tag",
		"operationReport": "Operation Report",
		"hawkersReport": "Hawkers Report",
		"rechargeManagement": "Balance Management"
	}
}
